import types from './types';


const updateList = (data) => ({
	type: types.UPDATE_LIST,
	payload: data
})

const updatePending = (data) => ({
	type: types.UPDATE_PINNED,
	payload: data
})


const updateHistory = (data) => ({
	type: types.UPDATE_HISTORY,
	payload: data
})

const updateDetails = (data) => ({
	type: types.UPDATE_DETAILS,
	payload: data
})


const clearList = () => ({
	type: types.CLEAR_LIST,
})

const updateMissedFilter = (filters) => ({
	type: types.UPDATE_MISSED_FILTER,
	payload: filters
})

const clearMissedFilter = () => ({
	type: types.CLEAR_MISSED_FILTER
})

const updatePendingFilter = (filters) => ({
	type: types.UPDATE_PENDING_FILTER,
	payload: filters
})

const clearPendingFilter = () => ({
	type: types.CLEAR_PENDING_FILTER
})


const updateFilter = (filters, type, tab) => ({
	type: types.UPDATE_FILTER,
	payload: {
		filters,
		type,
		tab
	}
})

const clearFilter = ( type, tab) => ({
	type: types.CLEAR_FILTER,
	payload: {
		type,
		tab
	}
})

export default {
	updateList,
	updatePending,
	updateDetails,
	updateHistory,
	clearList,
	updateMissedFilter,
	clearMissedFilter,
	updatePendingFilter,
	clearPendingFilter,
	updateFilter,
	clearFilter
};
